angular.module('app.entity.menu')
    .factory('EntityMenuPluginFormLock', [
        'RecordMetadataService',
        'CrfService',
        'RecordDataService',
        function(
            RecordMetadataService,
            CrfService,
            RecordDataService
        ) {
            function getFormLockInfo(elementId, listIndices) {
                return RecordMetadataService.getFormLock(elementId, listIndices);
            }

            function getSectionLockInfo(section, listIndices) {
                return {
                    value: section.getChildren().every(function(child) {
                        var childInfo;

                        if (child.isForm()) {
                            childInfo = getFormLockInfo(child.getId(), listIndices);
                        } else if (child.isSection()) {
                            childInfo = getSectionLockInfo(child, listIndices);
                        } else if (child.isList()) {
                            childInfo = getListLockInfo(child, listIndices);
                        }

                        return childInfo && childInfo.value;
                    }),
                };
            }

            function getListLockInfo(list, listIndices) {
                var listData = RecordDataService.getList(list.getId(), listIndices);
                if (!angular.isArray(listData) || listData.length === 0) {
                    return;
                }

                listIndices = listIndices || {};

                return {
                    value: listData.every(function(itemData, index) {
                        var itemIndices = angular.copy(listIndices);
                        itemIndices[list.getId()] = index + 1;

                        var itemInfo = getListItemLockInfo(list, itemIndices);

                        return itemInfo && itemInfo.value;
                    }),
                };
            }

            function getListItemLockInfo(list, listIndices) {
                return getSectionLockInfo(list, listIndices);
            }

            return {
                initFormFlags: function(itemMetadata, elementId, entityData, stateParams) {
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.locked = getFormLockInfo(elementId, listIndices);
                },
                initSectionFlags: function(itemMetadata, elementId, entityData, stateParams) {
                    var section = itemMetadata.element;
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.locked = section ? getSectionLockInfo(section, listIndices) : {};
                },
                initListFlags: function(itemMetadata, elementId, entityData, stateParams) {
                    var list = itemMetadata.element;
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.locked = list ? getListLockInfo(list, listIndices) : {};
                },
                initListItemFlags: function(itemMetadata, elementId, stateParams) {
                    var list = itemMetadata.element;

                    var itemId = itemMetadata.id;
                    var itemIndices = CrfService.getListIndices(stateParams);

                    if (angular.isUndefined(itemIndices[elementId])) {
                        itemIndices[elementId] = RecordDataService.getListItemIndex(elementId, itemId, itemIndices);
                    }

                    itemMetadata.locked = list ? getListItemLockInfo(list, itemIndices) : {};
                },
                reloadFlags: function(itemMetadata, elementId, elementType, sectionState, stateParams) {
                    var element = itemMetadata.element;
                    var listIndices = CrfService.getListIndices(stateParams);

                    if (itemMetadata.type === 'form') {
                        itemMetadata.locked = getFormLockInfo(elementId, listIndices);
                    } else if (itemMetadata.type === 'section') {
                        itemMetadata.locked = getSectionLockInfo(element, listIndices);
                    } else if (itemMetadata.type === 'list') {
                        itemMetadata.locked = getListLockInfo(element, listIndices);
                    }
                },
                reloadItemFlags: function(itemMetadata, itemState, stateParams, elementId) {
                    var element = itemMetadata.element;
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.locked = getListItemLockInfo(element, listIndices);
                },
            };
        },
    ]);
